import React from "react";
import ReactDOM from "react-dom";
import get from "lodash/get";

// import Toast from "~/components/ui/Toast";
import Share from "~/components/basic/Share";
import { ChannelType, ShareInfo } from "~/components/basic/Share/types";

export interface SharePanelProps {
  title?: string;
  enableQrCode?: boolean;
  qrCodeBg?: string;
  onClose?: () => void;
  onShare?: (shareInfo: ShareInfo, channelId: ChannelType) => void;
  afterShare?: (status: "success" | "cancel" | "fail") => void;
  visible: boolean;
  channelIds?: ChannelType[];
  getShareInfo?: (channelId: ChannelType) => ShareInfo | Promise<ShareInfo>;
}

type PortalProps = {
  children: React.ReactNode;
};

const Portal = (props: PortalProps): JSX.Element => {
  return ReactDOM.createPortal(props.children, document.body);
};

function SharePannel(props: SharePanelProps): JSX.Element | null {
  // 分享后隐藏分享弹窗(new)
  const afterShare = (res: any): void => {
    const success = get(res, "success");
    const errCode = get(res, "errCode");
    const status = success ? "success" : Number(errCode) === 1 ? "cancel" : "fail";
    // if (status === "success") {
    //   Toast.info(props.t("分享成功"));
    // } else if (status === "cancel") {
    //   Toast.info(props.t("取消分享"));
    // } else if (status === "fail") {
    //   Toast.fail(props.t("分享不成功"));
    // }
    const { afterShare } = props;
    afterShare && afterShare(status);
  };

  return process.browser ? (
    <Portal>
      <Share
        title={props.title}
        enableQrCode={props.enableQrCode}
        __test
        visible={props.visible}
        channelIds={
          props.channelIds || [
            ChannelType.Whatsapp,
            ChannelType.Line,
            ChannelType.Instagram,
            ChannelType.Facebook,
            ChannelType.Twitter,
            ChannelType.CopyLink,
          ]
        }
        onClose={props.onClose}
        onShare={props.onShare}
        getShareInfo={props.getShareInfo}
        afterShare={afterShare}
      />
    </Portal>
  ) : null;
}

export default SharePannel;
